import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {buildChipsFieldValidators} from './chips-field.builder';


export const chipsFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        setChipsFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity({emitEvent: false});
        return;
    }
    setChipsFieldValidators(currentFieldConfig, updateFieldConfig, control);
};

export const setChipsFieldValidators = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

    const validators = buildChipsFieldValidators(updatedFieldConfig);
    // we now use custom email valid for all fields
    // if (validators.indexOf(Validators.email) > -1) {
    //     validators.splice(validators.indexOf(Validators.email), 1);
    //     validators.push(customEmailValidator);
    // }
    control.setValidators(validators);
};
